import request from 'superagent';

class Http {
  public static get(url, id) {
    if (id) {
      url = `${url}/${id}`;
    }
    return request.get(url);
  }

  public static post(url, data) {
    return request.post(url, data);
  }

  public static put(url, data) {
    return request.put(url, data);
  }

  public static del(url, id, data) {
    if (id) {
      url = `${url}/${id}`;
    }
    return request.del(url, data);
  }

  public static save(url, data = {}) {
    let method = !!data.id ? 'put' : 'post';
    return request[method](url, data);
  }

  public static submit(req) {
    return new Promise((resolve, reject) => {
      let success = (res) => {
        resolve(res);
      };
      let error = (err) => {
        reject(err);
      };

      req.then(success, error);
    });
  }
}

export default Http;
